import React from 'react';

import { CarrotQuestManager } from '../CarrotQuestManager';
import { YandexMetricaManager } from '../YandexMetricaManager';

export const ExternalServices: React.FC = () => {
  const mode = import.meta.env.MODE;
  const isProduction = mode === 'production';
  return isProduction ? (
    <>
      <CarrotQuestManager />
      <YandexMetricaManager />
    </>
  ) : undefined;
};
